import axios, { AxiosError, AxiosRequestConfig, AxiosRequestHeaders, AxiosResponse } from "axios";
import { Problem } from "@/models/Error";

const culture = (document.getElementById("app") as HTMLElement).getAttribute("data-culture") as string;

const setDefaultHeaders = (headers: AxiosRequestHeaders) => {
  headers["X-Requested-With"] = "XMLHttpRequest";
  headers["Accept-Language"] = culture;
};

const createAxiosInstance = (baseURL: string) => {
  const instance = axios.create({
    baseURL: baseURL,
  });

  const handleError = (error: AxiosError<Problem>) => {
    if (error.response) {
      return Promise.reject(error.response.data);
    } else if (error.request) {
      const details: Problem = {
        detail: error.message,
        status: error.request.status,
        title: error.name,
      };
      return Promise.reject(details);
    }
    const details: Problem = {
      detail: error.message,
      status: 500,
      title: error.name,
    };
    return Promise.reject(details);
  };

  instance.interceptors.request.use((config: AxiosRequestConfig) => {
    setDefaultHeaders(config.headers as AxiosRequestHeaders);
    return config;
  }, handleError);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  instance.interceptors.response.use((response: AxiosResponse<any>) => {
    return response.data;
  }, handleError);

  return instance;
};

export default createAxiosInstance;
